import safeJSONParse from '@/utils/safeJSONParse'
import localStorage from '@/utils/localStorage'
import { STORAGE_KEYS } from '@/constants/storage'
import { DEFAULT_FEED_FILTER, FEED_FILTER_PREFERENCES } from '@/constants/activity'
import { ENTITY_TYPE } from '@/constants/entities'

function storageKey(entityType) {
  return {
    [ENTITY_TYPE.GOAL]: STORAGE_KEYS.goalFeedPreference,
    [ENTITY_TYPE.KEY_RESULT]: STORAGE_KEYS.keyResultFeedPreference,
    [ENTITY_TYPE.INITIATIVE]: STORAGE_KEYS.initiativeFeedPreference,
    [ENTITY_TYPE.IDEA]: STORAGE_KEYS.ideaFeedPreference
  }[entityType]
}

function retrieveSelectedFilterId(entityType) {
  const storageItem = localStorage.getItem(storageKey(entityType))
  const legacyObject = safeJSONParse(storageItem, true)
  return legacyObject ? legacyObject.id : storageItem || DEFAULT_FEED_FILTER.id
}

function storeSelectedFilterId(entityType, id) {
  localStorage.setItem(storageKey(entityType), id)
}

function filterFromId(id) {
  return FEED_FILTER_PREFERENCES.find(filter => filter.id === id)
}

export default {
  namespaced: true,
  state() {
    return {
      [ENTITY_TYPE.GOAL]: retrieveSelectedFilterId(ENTITY_TYPE.GOAL),
      [ENTITY_TYPE.KEY_RESULT]: retrieveSelectedFilterId(ENTITY_TYPE.KEY_RESULT),
      [ENTITY_TYPE.INITIATIVE]: retrieveSelectedFilterId(ENTITY_TYPE.INITIATIVE),
      [ENTITY_TYPE.IDEA]: retrieveSelectedFilterId(ENTITY_TYPE.IDEA)
    }
  },
  getters: {
    selectedFilter: state => entityType => filterFromId(state[entityType])
  },
  mutations: {
    SET_SELECTED_FILTER(state, { entityType, filter }) {
      state[entityType] = filter.id
      storeSelectedFilterId(entityType, filter.id)
    }
  }
}
